<div class="container">
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Edit Branche </h4>
    </div>
    <div class="card-body">

      <form [formGroup]="groupAgeForm" (ngSubmit)="onEditGroupAge()">
        <div class="row">
 

   <div class="col-md-4 form-group">
      <label class="form-label">Name</label>
      <input type="text" class="form-control"
             formControlName="name" />
      <small *ngIf="groupAgeForm.get('name')?.errors?.['maxlength']">
        Max length is 20 characters.
      </small>
    </div>

    <div class="col-md-4 form-group">
      <label class="form-label">Min Age</label>
      <input type="number" class="form-control"
             formControlName="minAge" />
    </div>

    <div class="col-md-4 form-group">
      <label class="form-label">Max Age</label>
      <input type="number" class="form-control"
             formControlName="maxAge" />
    </div>



  </div>



        <!-- Submit and Reset Buttons -->
        <div class="col-12 d-flex justify-content-center">
          <div class="d-flex justify-content-between ">
            <button type="submit" class="btn btnn mx-1" rippleEffect>Update </button>
            <!-- <button type="button" class="btn btn-light" (click)="resetForm()" rippleEffect>Reset</button> -->
          </div>
        </div>

      </form>
    </div>
  </div>
</div>